/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeDto } from '../../models/employee-dto';

export interface ApiEmployeeAllGet$Params {
  'api-version'?: string;
}

export function apiEmployeeAllGet(http: HttpClient, rootUrl: string, params?: ApiEmployeeAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeDto>>> {
  const rb = new RequestBuilder(rootUrl, apiEmployeeAllGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeDto>>;
    })
  );
}

apiEmployeeAllGet.PATH = '/api/employee/all';
